<template>
	<div id="app">
		<b-navbar toggleable="lg" type="dark" variant="secondary">
			<b-navbar-brand style="padding-left: 1em;" v-bind:to="{ name: 'home' }">
				<img src="@/assets/logo.png" style="max-width:60px; margin-right: 20px;"/>
				Randomizer
			</b-navbar-brand>

			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

			<b-collapse id="nav-collapse" is-nav>

				<b-navbar-nav>

				</b-navbar-nav>

				<b-navbar-nav class="ml-auto">
					<b-nav-item-dropdown right>
						<template #button-content>
							<b-icon-person></b-icon-person>
							{{ user.username }}
						</template>
                        <li>
                            <router-link :to="{ name: 'create' }" class='dropdown-item' >Home</router-link>
                        </li>
                        <li>
                            <router-link :to="{ name: 'home' }" class='dropdown-item'>View Projects</router-link>
                        </li>
                        <b-dropdown-item :to="{ name: 'logout' }">Logout</b-dropdown-item>
					</b-nav-item-dropdown>
				</b-navbar-nav>
			</b-collapse>
		</b-navbar>
		<b-container fluid>
			<b-alert dismissible class="m-3" :variant="alert.type" :show="alert.timeout" v-for="(alert, index) in alerts" @dismissed="alertDismissed(index)" :key="alert.id">{{ alert.message }}</b-alert>
			<router-view></router-view>
		</b-container>
	</div>
</template>

<script>
import { ALERT_REMOVE } from './store/actions/alerts'

export default {
	name: 'App',

	data () {
		return {}
	},

	computed: {
		user() {
			return this.$store.state.user.user;
		},

		alerts() {
			return this.$store.state.alerts.alerts;
		}
	},

	methods: {
		alertDismissed(index) {
			this.$store.dispatch(ALERT_REMOVE, index);
		}
	}
}
</script>

<style lang="scss">
@import 'assets/theme.scss';
@import '~bootstrap/scss/bootstrap.scss';
@import '~bootstrap-vue/src/index.scss';
@import 'assets/bootswatch.scss';
</style>
